module.exports = {
      id: "paywalliconbenefit-usage",
      viewBox: "0 0 33.788 14.247",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#paywalliconbenefit",
      toString: function () {
        return this.url;
      }
    }